/** OCR利用統計用セッションIDを formDataに付与する */
function appendOcrSessionId(formData: FormData): void {
  const ocrSessionId = localStorage.getItem('ocr_session_id')
  if (ocrSessionId) formData.append('ocr_session_id', ocrSessionId)
}

/** OEM情報をformDataに付与する */
function appendOemInfo(formData: FormData, vueInstance: any): void {
  const oemContext = vueInstance.$oemContext
  const isOemEnvironment = oemContext && oemContext.currentOemId

  formData.append('oem_flg', isOemEnvironment ? 'true' : 'false')

  if (isOemEnvironment && oemContext.currentOemUniqueId) {
    formData.append('oem_id', oemContext.currentOemUniqueId)
  } else {
    const cookieOemId = vueInstance.$cookies
      ? vueInstance.$cookies.get('_YAGISH_OEM_UNIQUE_ID')
      : null
    if (cookieOemId) {
      formData.append('oem_id', cookieOemId)
    }
  }
}

export type LoginFormUser = {
  uid: string
  email?: string | null
  emailVerified?: boolean
}

type BuildLoginFormOptions = {
  /** 空文字で送る（redirect で email 無しのとき） */
  email?: string
  includeConfirmCode?: boolean
  includeUnivId?: boolean
}

/** Varuna login 向け FormData を組み立てる（経路間で共通） */
export function buildVarunaLoginFormData(
  vueInstance: any,
  user: LoginFormUser,
  options: BuildLoginFormOptions = {}
): FormData {
  const formData = new FormData()
  formData.append('uuid', user.uid)
  const email = options.email !== undefined ? options.email : user.email || ''
  formData.append('email', email)

  if (options.includeConfirmCode) {
    const confirmCode = vueInstance.$cookies.get('_TEMPDATA_CONFIRM_CODE')
    formData.append('confirm_code', confirmCode)
  }

  const athleteUnivId = vueInstance.$cookies.get('_YAGISH_ATHLETE_UNIVID')
  if (athleteUnivId) formData.append('athlete_univ_id', athleteUnivId)
  const affiliateId = vueInstance.$cookies.get('_YAGISH_AFFILIATE_ID')
  if (affiliateId) formData.append('affiliate_id', affiliateId)

  formData.append('app_flag', vueInstance.$site.appFlag)
  formData.append('site_flag', 'r')
  if (options.includeUnivId) {
    formData.append('univ_id', '')
  }
  formData.append('email_verified', user.emailVerified ? '1' : '0')
  formData.append(
    'device_flag',
    vueInstance.$deviceLib.isMobileDevice ? 'SP' : 'PC'
  )
  appendOcrSessionId(formData)
  appendOemInfo(formData, vueInstance)
  return formData
}

/** Varuna login を POST する（購読側ゼロの login_redirect_function 発火は削除済み） */
export function postVarunaLogin(vueInstance: any, formData: FormData): void {
  vueInstance.$axios
    .post(vueInstance.$varuna.endPoints.login, formData)
    .catch(function (error: unknown) {
      console.error(error)
    })
}
